import authenticate from 'basic-auth';
import compare from 'tsscmp';

/**
 * Extracts the hostname from the url
 * When set it instantly returns the DEBUG_WAGTAIL_API_HOSTNAME
 *
 * @param {string} host
 * @returns {string}
 */
const getHostname = (url) => {
  if (process.env.DEBUG_WAGTAIL_API_HOSTNAME) {
    return process.env.DEBUG_WAGTAIL_API_HOSTNAME;
  }
  return url.split(':')[0];
};

/**
 * A pipe seperated username and password combination.
 *
 * @param {string} credentials
 */
const parseCredentials = (credentials) => {
  const authCredentials = [];

  credentials.split('|').forEach((item) => {
    if (item.length < 3) {
      throw new Error(`Received incorrect basic auth syntax, use <username>:<password>, received ${item}`);
    }
    const parsedCredentials = item.split(':');
    if (parsedCredentials[0].length === 0 || parsedCredentials[1].length === 0) {
      throw new Error(`Received incorrect basic auth syntax, use <username>:<password>, received ${item}`);
    }

    authCredentials.push({
      name: parsedCredentials[0],
      password: parsedCredentials[1],
    });
  });

  return authCredentials;
};

/**
 * Validate if a user object matches a list of known credentials
 *
 * @param {object} user The property which passes the input credentials
 * @param {array} credentials Contains a list of credentials to match for
 */
const compareCredentials = (user, credentials) => {
  const passedCredentials = credentials.find((item) => item.name === user.name);
  if (typeof passedCredentials === 'undefined') {
    return false;
  }

  return compare(user.name, passedCredentials.name) && compare(user.pass, passedCredentials.password);
};

/**
 * Adds a Basic authentication check based upon request
 *
 * @param {IncomingMessage} req
 * @param {ServerResponse} res
 */
const basicAuthMiddleware = async (req, res) => {
  const environmentCredentials = process.env.BASIC_AUTH_CREDENTIALS || '';
  if (environmentCredentials.length === 0) {
    // No credentials set up, continue rendering the page as normal
    return;
  }

  const credentialsObject = parseCredentials(environmentCredentials);
  const currentUser = authenticate(req);

  if (!currentUser || !compareCredentials(currentUser, credentialsObject)) {
    res.statusCode = 401;
    res.setHeader('WWW-Authenticate', `Basic realm="protected"`);
    res.end('401 Unauthorized');
  }
};

export default basicAuthMiddleware;
export { compareCredentials, getHostname, parseCredentials };
